<template>
    <button type="button" class="btn btn-sm btn-outline-secondary" @click="copyText">
        <i :class="copied ? 'fa fa-check' : 'fa fa-clipboard'"></i>
        {{ copied ? $t('Copied!') : $t('Copy') }}
    </button>
</template>

<script setup>
import { useClipboard } from '@vueuse/core'

const props = defineProps({
    value: {
        type: String,
        required: true,
    },
})

const { copy, copied } = useClipboard()

function copyText() {
    copy(props.value)
}
</script>
